var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDropdownV2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6333_2665)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7328 12.9467C10.4074 13.2721 9.8797 13.2721 9.55429 12.9467L4.8402 8.23261C4.51479 7.90721 4.51479 7.37957 4.8402 7.05413C5.1657 6.7287 5.69329 6.7287 6.01879 7.05413L10.1435 11.1789L14.2683 7.05413C14.5938 6.7287 15.1214 6.7287 15.4468 7.05413C15.7723 7.37958 15.7723 7.90721 15.4468 8.23261L10.7328 12.9467Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6333_2665"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdownV2);
export default __webpack_public_path__ + "static/media/dropdown_v2.9d98fe141634b35423e0463d1c937de8.svg";
export { ForwardRef as ReactComponent };